<div (click)="windowClick()" [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'">
  <dialog-header [label]="'Playback Mode'" [dialogRef]='dialogRef' [object]='this'
    style="width: 900; text-align: left;"></dialog-header>
  <div fxLayout="column" fxLayoutAlign="center center" style="margin: 10px;">
    <div matRipple style="border-radius: 15px; user-select: none;">
      <input class="field-input" type="text" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1"
        placeholder="Date Time" autocomplete="off" style="width: 296px; cursor: pointer;" [(ngModel)]="selectedDate" 
        [max]="currentDateTime" (click)="onDatePickerOpen()" readonly
      >
      <owl-date-time #dt1  [showSecondsTimer]="true"></owl-date-time>

    </div>
    <div class="button-border-margin" fxLayoutAlign="center center">
      <button mat-stroked-button (click)="onDateSelected(selectedDate)">Play</button>
    </div>
  </div>
</div>